import {investments_api} from "@/store/resources"

export default {
    namespaced: true,
    state: {
        brokers: []
    },
    getters:{
        brokersList:(state)=> state.brokers
    },
    actions: {
        async getBrokers({commit}) {
            try {
                const res = await investments_api.invest_brokers.get()
                commit('setBrokers', res.body.data.rows)
            } catch (e) {
                console.log(e)
            }
        },
    },
    mutations: {
        setBrokers(state, brokers) {
            state.brokers = brokers;
        }
    }
}